<template>
	<div>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-解决方案池</span>-常见问题</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			
			<div class="body-main" style="width: 1200px;margin: 0 auto;">
			
			<div class="main-body">
				<div class="title">
					<div :class="'active'">常见问题</div>
			
				</div>
				<div class="showItem">
					<div style="padding-bottom: 20px;border-bottom:1px dashed #F0F0F0;margin-bottom: 20px;" v-for="(item,index) in questionList">
						<div>
							<span style="background: #0052D9;color: white;font-size: 20px;width: 23px;height: 23px;display: inline-block;line-height: 23px;text-align: center;">Q</span>
							<span style="font-size: 20px;color: black;margin-left: 10px;">{{item.question}}</span>
						</div>
						<div style="margin-top: 15px;display: flex;">
							<span style="background: #EEEEEE;color: black;font-size: 20px;width: 23px;height: 23px;display: inline-block;line-height: 23px;text-align: center;">A</span>
							<p style="margin-left: 10px;flex: 1;"> {{item.answer}}</p>
						</div>
					</div>
				</div>
				
			</div>
			



			</div>
	
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

				shoucang: false,
				noLike:false,
				heart:false,
				share:false,
					result: [],
					showDetail:false,
					questionList:[]

			}
		},
		created() {
			this.getQuestions()
		},

		methods:{
			async getQuestions(){
				const que = await this.$api.usuallyQuestions({cate_id:this.$route.query.type})
				this.questionList = que.data
				console.log(que);
			},
			goto(url){
				this.$router.push(url)
			},
			
		}
	}
</script>

<style lang="less" scoped>
	
	.main-item {
		text-align: center;
		cursor: pointer;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
	}
	
	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;
	
	}
	
	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}
	
	.body-mid-main {
		display: flex;
		flex-wrap: wrap;
	
		justify-content: flex-start;
	}
	
	.main-item {
		margin: 13px;
		margin-left: 18px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
	}
	.body {
		display: flex;
		justify-content: space-between;
		.table{
			border: 1px solid #EEEEEE;
			text-align: center;
			.table-line{
				.jindu{
					width: 130px;
				}
				.line-status{
					width: 120px;
					border:  1px solid #EEEEEE;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.starScore{
					font-size: 30px;
					width: 190px;
					border:  1px solid #EEEEEE;
					display: flex;
					height: 100%;
					align-items: center;
					justify-content: center;
				}
				.zhuanjia{
					display: flex;
					flex: 1;
					justify-content: flex-end;
					div{
						margin-right: 20px;
						width: 132px;
						color: #0052D9;
						height: 34px;
						border: 1px solid #0052D9;
						line-height: 34px;
						cursor: pointer;
					}
					&>div:last-child{
						background: #0052D9;
						color: white;
					}
				}
				.line-icon{
					width: 75px;
					display: flex;
					justify-content: center;
					border:  1px solid #EEEEEE;
					height: 100%;
					align-items: center;
					img{
						width: 23px;
						height: 23px;
					}
				}
				.line-id{
					font-size: 18px;
					width: 75px;
				}
				.fangan{
					width: 210px;
				}
				.nickName{
					width: 200px;
				}
				.company{
					width: 250px;
				}
				.deal{
					width: 180px;
				}
				.score{
					width: 120px;
				}
				.status{
					width: 170px;
				}
				align-items: center;
				display: flex;
				font-size: 16px;
				border-bottom: 1px solid #EEEEEE;
				height: 55px;
				.line-check{
					display: flex;
					align-items: center;
					justify-content: center;
					width: 50px;
					border:  1px solid #EEEEEE;
					height: 100%;
				}
			}
			.darkbg{
				background: #FAFAFA;
			}
		}
		.body-item-title {
			display: flex;
			justify-content: space-between;
			font-size: 18px;
			padding: 20px;
			align-items: center;
		
			&>div {
				cursor: pointer;
				line-height: 40px;
				text-align: center;
				padding: 0 10px;
				height: 40px;
				background: #F6F6F6;
				border: 1px solid #D2D2D2;
			}
		}
		.body-left {
			.left-body {
				.guanzhu {
					width: 230px;
					height: 46px;
					background: #0052D9;
					line-height: 46px;
					color: white;
					text-align: center;
					cursor: pointer;
				}

				.body-item {
					margin: 10px 0;
					margin-bottom: 30px;
				}

				.item-title {
					font-size: 18px;
					margin-bottom: 10px;
				}

				.item-content {
					margin: 5px 0;
					color: #888888;
				}

				padding: 10px 15px;
				box-sizing: border-box;
			}

			.left-head {
				font-size: 20px;
				line-height: 69px;
				padding-left: 15px;
				box-sizing: border-box;
				font-weight: bold;
				width: 260px;
				height: 69px;
				color: #0052D9;
				background: #E5EDFB;
			}

			width: 260px;
			height: 250px;
			background: #FFFFFF;
		}
		.body-mid-footer {
			display: flex;
			padding: 20px;
			box-sizing: border-box;
			height: 50px;
			background: #F6F6F6;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
			align-items: center;
			margin:10px auto;
			&>img {
				margin-left: 20px;
				width: 16px;
				height: 16px;
			}
		}
		.body-main {
			width: 900px;

			.main-body {
				.showItem {
					padding: 30px 25px;
					color: #888888;
					.bottom{
						height: 50px;
						background: #F6F6F6;
						border: 1px solid #EEEEEE;
						margin-top:50px;
						line-height: 50px;
						padding-left: 30px;
						box-sizing: border-box;
						color: black;
					}
					.yingzu{
						display: flex;
						align-items: center;
						margin: 15px 0;
						img{
							width: 18px;
							height: 18px;
						}
						&>span{
							margin-left: 10px;
						}
						&>span:last-child{
							margin-left: 30px;
						}
					}
					p {
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.wangpan {
						color: black;
						height: 200px;

						input {
							border: 1px solid #c6c6c6;
							height: 25px;
							padding-left: 5px;
							width: 200px;
						}
					}
				}

				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						text-align: center;
						color: #888888;
						padding: 0 20px;
					}

					.active {
						font-weight: bold;
						color: white;
						border-radius: 20px;
						height: 40px;
						background: #0052D9;
						border-radius: 0px 20px 20px 0px;
					}
				}

				margin-top: 20px;
				padding: 20px 0;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;
					display: flex;

					.biaoti {
						width: 60px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 25px 5px;
						width: 280px;
					}

					.content-l {}
				}




				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;
					.bottom{
						color: #888888;
						margin: 15px 0;
						margin-top: 50px;
					}
					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
</style>